import { DateTime } from 'luxon';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useValueSelector } from '../../hooks/useValueSelector';
import { RootState } from '../../store';
import { ItemType } from '../../types';

export const useScrollToCurrentItem = (handleScrollX: (scrollLeft: number) => void) => {
    const currentGantItem = useValueSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);
    const startDateExtend = useSelector<RootState, string>((state) => state.gant.startDateExtend);
    const widthColumn = useSelector<RootState, number>((state) => state.gant.widthColumn);
    const availableWidth = useSelector<RootState, number>((state) => state.gant.availableWidth);
    const currentScrollX = useSelector<RootState, number>((state) => state.gantScroll.currentScrollX);
    const widthLeftHeader = useSelector<RootState, number>((state) => state.gant.widthLeftHeader);

    useEffect(() => {
        if (!currentGantItem) {
            return;
        }

        const timelineStart = DateTime.fromISO(startDateExtend);

        const itemStart = DateTime.fromISO(currentGantItem.startDate);
        const { days: startDaysDiff } = itemStart.diff(timelineStart, 'days');
        const itemStartX = Math.floor(Math.max(startDaysDiff - 1, 0) * widthColumn);

        const itemEnd = DateTime.fromISO(currentGantItem.endDate);
        const { days: endDaysDiff } = itemEnd.diff(timelineStart, 'days');
        const itemEndX = Math.floor(endDaysDiff * widthColumn);

        const visibleStart = currentScrollX;
        const visibleEnd = currentScrollX + availableWidth - widthLeftHeader;

        if (
            (itemStartX >= visibleStart && itemStartX <= visibleEnd) ||
            (itemEndX >= visibleStart && itemEndX <= visibleEnd)
        ) {
            return;
        }

        handleScrollX(itemStartX);
    }, [currentGantItem]);
};
